import React, { useState, useEffect } from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBInputGroup,
} from "mdb-react-ui-kit";
import "../../styles/practitionerpage.css";
import "../../styles/homepage.css";
import { Link } from "react-router-dom";
import woman from "../../img/practitionerImage2.jpg";
import BlowHorn from "../../img/BlowHorn.png";
import Calendar from "../../img/Calendar.png";
import LightBulb from "../../img/LightBulb.png";
import { useDispatch } from "react-redux";
import { addEmailRecipient } from "../../features/emailCollection/emailCollectionSlice";
import { NewFooter } from "../../components/newFooter";
import filterOne from "../../img/filter_1.png";
import filterTwo from "../../img/filter_2.png";
import filterThree from "../../img/filter_3.png";
import keyRi from "../../img/newKeyBoardArrow.png";
export const PractitionerPage = () => {
  const dispatch = useDispatch();

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [newsletterEmail, setNewsletterEmail] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const addEmailToNewsletterList = (email) => {
    dispatch(addEmailRecipient({ email: email, type: "Newsletter" }));
    setNewsletterEmail("");
  };

  return (
    <div>
      {/* Practitioner Banner 1 - Grow your practice*/}
      <div
        className={
          windowDimensions.width <= 692
            ? "bg-practitioner-mobile"
            : "bg-practitioner "
        }
      >
        <div className="padding-letters-two center-mobile-text">
          <h1 className="margin-text-home  title-home-practitioner mt-5">
            Empower Women with Pelvic Care
          </h1>
          <p className="margin-text-home-small-practitioner  text-individual-home text-dark">
            Change the way women experience pelvic care{" "}
            <br className="display-later" /> <br className="display-1285" />
            as a <br className="display-2000" />
            practitioner. Together, we can make it better.
          </p>
          <Link className="text-decoration-none" to="/practitionerSignUp">
            <button className="margin-text-home-small button-newindividualpage blue-hover">
              REGISTER NOW
            </button>
          </Link>
        </div>
      </div>
      {/* <div className="practitioner-page-banner-1">
        <h1 className="text-center text-al fs-40-24 fw-bolder">
          Grow your Practice with Elana
        </h1>
        <h3 className="text-center text-dm fs-20-18 fw-light m-0">
          Together we can transform<br className="desktop-view-hidden"/>{" "}women's health
        </h3>
        <div className="d-flex justify-content-center pt-2">
          <Link to="/practitionerSignUp" className="link">
            <button className="brand-bg-purple text-white blue-hover practitioner-button-1 text-dm border border-0 tag-buttom  homepage-cards-button">
              REGISTER NOW
            </button>
          </Link>
        </div>
      </div> */}

       {/* Practitioner Banner 2 - How Elana can help Practitioners*/}
       <div className="practitioner-page-banner-2 p-5 ">
        <h1 className="text-center text-al fs-40-24 fw-bolder">
          Elana can help you build a thriving practice
        </h1>
        <h3 className="text-center text-dm fs-20-18 fw-light p-2">
          We are on a mission to make it easier for practitioners to reach women
          who want to
          <br className="mobile-view-hidden"/>
          take control of their pelvic health. We are actively building our
          network.
        </h3>

        <MDBRow>
          <MDBCol className="d-flex justify-content-center pad-practitioner-box" lg="4">
            <MDBCard
              className="border border-0 border-radius-9 brand-bg-purple-2 practitioner-cards"
              
            >
                            <MDBCardBody className="d-flex align-items-center justify-content-center">
                <MDBCardTitle className="text-center line-height-loose">
                  <div className="d-flex justify-content-center mb-2">
                    <img src={BlowHorn} alt="more" />
                  </div>
                  <p className="fs-24-20 text-al ">Reach more patients</p>

                  <span className="fs-16-14 text-dark text-dm text-nowrap text-skinny">

                    Fill up your patient load on your
                    <br />
                    terms with telehealth and in-
                    <br />
                    person appointments.
                  </span>
                </MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol className="d-flex justify-content-center pad-practitioner-box" lg="4">
            <MDBCard
              className="border border-0 border-radius-9 brand-bg-purple-2 practitioner-cards"
              
            >
              <MDBCardBody className="d-flex align-items-center justify-content-center">
                <MDBCardTitle className="text-center line-height-loose">
                  <div className="d-flex justify-content-center mb-2">
                    <img src={Calendar} alt="more" />
                  </div>
                  <p className="fs-24-20 text-al ">Connect with Practitioners</p>
                  <span className="fs-16-14 text-dark text-dm text-nowrap text-skinny">
                    Collaborate with the other practitioners
                    <br />
                    and the Elana team to help us improve
                    <br />
                    women’s health.{" "}
                  </span>
                </MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol className="d-flex justify-content-center pad-practitioner-box" lg="4">
            <MDBCard
              className="border border-0 border-radius-9 brand-bg-purple-2 practitioner-cards"
              
            >
              <MDBCardBody className="d-flex align-items-center justify-content-center">
                <MDBCardTitle className="text-center line-height-loose">
                  <div className="d-flex justify-content-center mb-2">
                    <img src={LightBulb} alt="more" />
                  </div>
                  <p className="fs-24-20 text-al">Generate Awareness</p>
                  <span className="fs-16-14 text-dark text-dm text-nowrap text-skinny fs-helen-8">
                    Reach more patients by offering
                    <br />
                    courses and content through
                    <br />
                    Elana’s platform.
                  </span>
                </MDBCardTitle>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          </MDBRow>
          </div>
      
      {/* Practitioner Banner 3 - Practitioner To Register */}
      <div className="practitioner-page-banner-3">
        <div className="d-flex justify-center-responsive">
          <MDBRow>
          <MDBCol md="6">
              <div className="p-grey ">
                <div className="px-2 ms-3">
                  <h1 className="text-al fs-32-24-18 center-p-two title-practitioner-grey-banner">
                    Are you a practitioner passionate about{" "}
                     {/* <br className="mobile-view-hidden"/>  */}
                    women's pelvic health{" "}and wellness?
                  </h1>
                </div>
                <div className="">

                  <h4 className="text-dm fs-24-16 mt-1 mb-2 center-p-two ms-3">

                    Joining Elana is simple<br className="desktop-view-hidden"/>{" "}and free.
                    </h4>
                </div>
                <div>

                  <div className="me-0 mx-auto">
                    <p className="text-dm fs-24-16 p-2 text-start text-skinny center-p">
                    <i className="fas fa-circle"></i>Fill out the online application  </p>
                    <p className="text-dm fs-24-16 p-2 text-start text-skinny textfoot center-p">
                    <i className="fas fa-circle"/>Provide us with your <br className="br-small"/>basic information
                    </p>
                    <p className="text-dm fs-24-16 p-2 text-start text-skinny center-p"><i className="fas fa-circle"></i>We will be in touch!</p>
                  </div>

                </div>
  
                <div className="center-p ms-3">
                  <Link to="/practitionerSignUp" className="">
                    <button className="brand-bg-purple blue-hover text-white text-dm practitioner-button-1 border border-0 homepage-cards-button">
                    REGISTER NOW
                    </button>
                  </Link>
                </div>
              </div>
            </MDBCol>
            <MDBCol md="6" className="hidden">
              {/* <div className="image-div"> */}
                <img
                  className="img-fit"
                  src={woman}
                  alt="female-practitioner"
                />
              {/* </div> */}
            </MDBCol>
          </MDBRow>
          </div>
          </div>

      {/* Practitioner Banner 4 - Call to Action (Email) */}
      <div className="homepage-banner-8 p-5 padding-galaxy-cta">
        <h1 className=" text-center text-al fs-34-24 text-black">
          Connect with the ELANA community, we’ll only send you the important
          stuff.
        </h1>
        <h3 className="text-center text-al fs-24-20 text-black">
          Get updates and the latest info on pelvic care delivered to your
          inbox.
        </h3>
        <div className="d-flex justify-content-center">
          <MDBInputGroup className="email-width mt-3">
            <input
              className="text-dm text-spacing-minus-1 form-control p-2"
              placeholder="Enter your email"
              type="text"
              value={newsletterEmail}
              onChange={(e) => {
                setNewsletterEmail(e.target.value);
              }}
            />
            {windowDimensions.width > 500 ? (
              <button
                onClick={() => addEmailToNewsletterList(newsletterEmail)}
                className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover text-dm"
              >
                STAY IN THE KNOW
              </button>
            ) : (
              <button
                onClick={() => addEmailToNewsletterList(newsletterEmail)}
                className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover px-4 text-dm"
              >
                JOIN
              </button>
            )}
          </MDBInputGroup>
        </div>
        <h5 className="px-5 text-center text-dm text-spacing-minus-1 fs-16 fw-lighter hidden mt-5 text-black">
          Disclaimer: The information provided through Elana Health website and
          services is not intended
          <br />
          or implied to be a substitute for professional medical advice,
          diagnosis or treatment.
        </h5>
      </div>
      <NewFooter />
    </div>
  );
};
